import { useRef } from 'react'
import { ACTS, type SceneActId } from '@/constants/acts'
import { remapProgress } from '@/lib/utils/math'
import { useSceneStore } from '@/stores/scene-store'

function resolveActRange(id: SceneActId): { start: number; end: number } {
  const act = ACTS.find((entry) => entry.id === id)
  if (!act) {
    return { start: 0, end: 1 }
  }
  return { start: act.start, end: act.end }
}

const SEMENTE_RANGE = resolveActRange('semente')
const FLOR_RANGE = resolveActRange('flor')
const BUQUE_RANGE = resolveActRange('buque')
const JARDIM_RANGE = resolveActRange('jardim')
const ENTREGA_RANGE = resolveActRange('entrega')
const ATELIE_RANGE = resolveActRange('atelie')

export function useHomeModel() {
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const rawProgress = useSceneStore((state) => state.rawProgress)
  const isSceneReady = useSceneStore((state) => state.sceneReady)

  return {
    scrollContainerRef,
    isSceneReady,
    heroProgress: remapProgress(
      rawProgress,
      SEMENTE_RANGE.start,
      SEMENTE_RANGE.end,
    ),
    bloomProgress: remapProgress(rawProgress, FLOR_RANGE.start, FLOR_RANGE.end),
    bouquetProgress: remapProgress(
      rawProgress,
      BUQUE_RANGE.start,
      BUQUE_RANGE.end,
    ),
    gardenProgress: remapProgress(
      rawProgress,
      JARDIM_RANGE.start,
      JARDIM_RANGE.end,
    ),
    deliveryProgress: remapProgress(
      rawProgress,
      ENTREGA_RANGE.start,
      ENTREGA_RANGE.end,
    ),
    finaleProgress: remapProgress(
      rawProgress,
      ATELIE_RANGE.start,
      ATELIE_RANGE.end,
    ),
  }
}
